// import React, {
//   useState,
//   useMemo,
//   useCallback,
//   useEffect,
//   useRef,
// } from "react";
// import { ChevronLeft, ChevronRight, Info, Plus } from "lucide-react";
// import { FormService } from "@shared/services/FormServices";
// import { DynamicForm } from "@shared/components/DynamicForm";
// import { UseFormReturn } from "react-hook-form";
// import { useActiveUtilityServices } from "@shared/hooks/useActiveUtililyServices";
// import {
//   useBasisTypeOptions,
//   useRateNameOptions,
//   useRateTypeOptions,
//   useUpdatePlanMutation,
// } from "@features/onboarding/utility-setup/hooks";
// import { useNavigate, useParams } from "react-router-dom";
// import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
// import { Button } from "@shared/ui/button";

// interface UtilityServicesStepProps {
//   onNext?: () => void;
//   onPrevious?: () => void;
//   isFirstStep?: boolean;
//   isLastStep?: boolean;
//   currentStepIndex?: number;
//   totalSteps?: number;
//   data?: any;
//   onDataChange?: (data: any) => void;
//   setValidationError?: (error: string) => void;
//   clearValidationError?: () => void;
//   stepChange?: (data: any) => void;
// }

// const UtilityServicesStep: React.FC<UtilityServicesStepProps> = ({
//   onNext,
//   onPrevious,
//   isFirstStep,
//   isLastStep,
//   currentStepIndex = 2,
//   totalSteps = 4,
//   data = {},
//   onDataChange,
//   setValidationError,
//   clearValidationError,
//   stepChange,
// }) => {
//   console.log(
//     "🚀 UtilityServicesStep rendered with data:",
//     JSON.stringify(data, null, 2)
//   );

//   // ============================================================================
//   // STATE MANAGEMENT
//   // ============================================================================
//   const [isFormPopulated, setIsFormPopulated] = useState(false);
//   const [serviceConfigs, setServiceConfigs] = useState<
//     Record<number, { rateType: string; basisType: string; serviceId: string }>
//   >({});
//   const [forceRender, setForceRender] = useState(0);

//   // Refs to prevent infinite loops
//   const isUpdatingFormRef = useRef(false);
//   const lastSelectedServicesRef = useRef<string[]>([]);

//   // ============================================================================
//   // HOOKS & API
//   // ============================================================================
//   const { planId, action } = useParams<{ planId?: string; action: string }>();
//   const parsedPlanId = planId ? Number(planId) : null;
//   const utilityId = useRemoteUtilityId();
//   const updatePlanMutation = useUpdatePlanMutation(parsedPlanId);
//   const navigate = useNavigate();

//   const { data: activeUtilityServices, isLoading: loadingUtilityServices } =
//     useActiveUtilityServices();
//   const { data: rateTypes } = useRateTypeOptions();

//   // ============================================================================
//   // UTILITY SERVICES PROCESSING
//   // ============================================================================
//   const utilityServices = useMemo(() => {
//     if (!activeUtilityServices || activeUtilityServices.length === 0) {
//       return [];
//     }

//     return activeUtilityServices.map((service) => ({
//       id: service.name,
//       name: service.name,
//       unit: service.utilityUnit || "units",
//       originalId: service.id,
//       ...service,
//     }));
//   }, [activeUtilityServices]);

//   const rateTypeOptions = useMemo(() => {
//     return (
//       rateTypes?.map((item) => ({
//         label: item.value,
//         value: item.key,
//       })) ?? []
//     );
//   }, [rateTypes]);

//   const utilityServiceOptions = useMemo(() => {
//     return utilityServices.map((service) => ({
//       value: service.name,
//       label: service.name,
//     }));
//   }, [utilityServices]);

//   // ============================================================================
//   // TRANSFORM INITIAL DATA
//   // ============================================================================
//   const transformedInitialData = useMemo(() => {
//     console.log("🔧 Transforming initial data:", data);

//     const result: any = {
//       selectedServices: [],
//     };

//     // Handle rateData structure
//     if (
//       data.utilityService &&
//       data.rateData &&
//       Object.keys(data.rateData).length > 0
//     ) {
//       console.log("📦 Processing rateData structure");
//       result.selectedServices = Array.isArray(data.utilityService)
//         ? data.utilityService
//         : [data.utilityService];

//       const configs: Record<number, any> = {};
//       let index = 0;

//       Object.keys(data.rateData).forEach((serviceId) => {
//         const rateInfo = data.rateData[serviceId];
//         const rateType = rateInfo.type?.toString() || "";
//         const basisType =
//           rateInfo.type === 1 &&
//           rateInfo.basis !== null &&
//           rateInfo.basis !== undefined
//             ? rateInfo.basis?.toString() || ""
//             : "";

//         configs[index] = {
//           serviceId,
//           rateType,
//           basisType,
//         };

//         result[`service_${index}_name`] = serviceId;
//         result[`service_${index}_rateType`] = rateType;
//         result[`service_${index}_basisType`] = basisType;
//         result[`service_${index}_rateName`] = rateInfo.rate || "";
//         result[`service_${index}_avgConsumption`] =
//           rateInfo.avgConsumption || 0;

//         index++;
//       });

//       return { ...result, configs };
//     }

//     // Handle utility_configurations structure
//     if (
//       data.utility_configurations &&
//       Array.isArray(data.utility_configurations)
//     ) {
//       console.log("📦 Processing utility_configurations structure");

//       result.selectedServices = data.utility_configurations.map(
//         (config: any) => config.serviceName
//       );

//       const configs: Record<number, any> = {};

//       data.utility_configurations.forEach((config: any, index: number) => {
//         const serviceName = config.serviceName;
//         const rateType = config.rateType || "";
//         const basisType = config.basisType || "";

//         configs[index] = {
//           serviceId: serviceName,
//           rateType,
//           basisType,
//         };

//         result[`service_${index}_name`] = serviceName;
//         result[`service_${index}_rateType`] = rateType;
//         result[`service_${index}_basisType`] = basisType;
//         result[`service_${index}_rateName`] = config.rateName || "";
//         result[`service_${index}_avgConsumption`] = config.avgConsumption || 0;
//       });

//       return { ...result, configs };
//     }

//     // Handle selectedServices from stepper navigation
//     if (data.selectedServices && Array.isArray(data.selectedServices)) {
//       console.log("📦 Processing selectedServices from stepper");
//       result.selectedServices = data.selectedServices;

//       // If we have utility_service_data, use it
//       if (data.utility_service_data) {
//         const configs: Record<number, any> = {};

//         data.selectedServices.forEach((serviceName: string, index: number) => {
//           const serviceData = data.utility_service_data[serviceName];
//           if (serviceData) {
//             const rateType = serviceData.rateType || "";
//             const basisType = serviceData.basisType || "";

//             configs[index] = {
//               serviceId: serviceName,
//               rateType,
//               basisType,
//             };

//             result[`service_${index}_name`] = serviceName;
//             result[`service_${index}_rateType`] = rateType;
//             result[`service_${index}_basisType`] = basisType;
//             result[`service_${index}_rateName`] = serviceData.rateName || "";
//             result[`service_${index}_avgConsumption`] =
//               serviceData.avgConsumption || 0;
//           }
//         });

//         return { ...result, configs };
//       }
//     }

//     // Default fallback
//     console.log("📦 Using default empty structure");
//     return {
//       selectedServices: data.selectedServices || [],
//     };
//   }, [data]);

//   // ============================================================================
//   // BASIS TYPE FETCHER COMPONENT
//   // ============================================================================
//   const BasisTypeFetcher = ({
//     rateTypeKey,
//     onDataReceived,
//   }: {
//     rateTypeKey: string;
//     onDataReceived: (rateType: string, options: any[]) => void;
//   }) => {
//     const { data: basisTypes = [], isLoading } =
//       useBasisTypeOptions(rateTypeKey);

//     useEffect(() => {
//       if (!isLoading && basisTypes.length > 0) {
//         const options = basisTypes.map((sc: any) => ({
//           label: sc.value,
//           value: sc.key,
//         }));
//         console.log(
//           `🔄 Fetched basis types for rateType=${rateTypeKey}:`,
//           options
//         );
//         onDataReceived(rateTypeKey, options);
//       }
//     }, [basisTypes, isLoading, rateTypeKey, onDataReceived]);

//     return null;
//   };

  

//   // ============================================================================
//   // RATE NAME FETCHER COMPONENT
//   // ============================================================================
//   const RateNameFetcher = ({
//     serviceId,
//     serviceIndex,
//     rateTypeKey,
//     basisTypeValue,
//     onDataReceived,
//   }: {
//     serviceId: string;
//     serviceIndex: number;
//     rateTypeKey: string;
//     basisTypeValue?: string;
//     onDataReceived: (
//       serviceIndex: number,
//       options: any[],
//       rateData: any[]
//     ) => void;
//   }) => {
//     const queryParams = useMemo(() => {
//       if (rateTypeKey === "0") {
//         return {
//           type: "rate_type",
//           value: rateTypeKey,
//           utilityService: serviceId,
//         };
//       } else if (rateTypeKey === "1" && basisTypeValue) {
//         return {
//           type: "basis_type",
//           value: basisTypeValue,
//           utilityService: serviceId,
//         };
//       }
//       return null;
//     }, [rateTypeKey, basisTypeValue, serviceId]);

//     const { data: rateNames = [], isLoading } = useRateNameOptions(queryParams);
//     const rateNamesArray = rateNames as any[];

//     useEffect(() => {
//       if (!isLoading && rateNamesArray.length > 0 && queryParams) {
//         const options = rateNamesArray.map((sc: any) => ({
//           label: sc.rateName,
//           value: sc.id,
//         }));
//         console.log(
//           `🔄 Fetched rate names for service ${serviceId} (index ${serviceIndex}):`,
//           options
//         );
//         onDataReceived(serviceIndex, options, rateNamesArray);
//       }
//     }, [rateNamesArray, isLoading, queryParams, onDataReceived, serviceIndex]);

//     return null;
//   };

//   // ============================================================================
//   // OPTION CACHES FOR DROPDOWNS
//   // ============================================================================
//   const [basisTypeOptionsCache, setBasisTypeOptionsCache] = useState<
//     Record<string, any[]>
//   >({});
//   const [rateNameOptionsCache, setRateNameOptionsCache] = useState<
//     Record<number, any[]>
//   >({});

//   const handleBasisTypeOptionsReceived = useCallback(
//     (rateType: string, options: any[]) => {
//       setBasisTypeOptionsCache((prev) => ({
//         ...prev,
//         [rateType]: options,
//       }));
//       console.log(`✅ Cached basis type options for ${rateType}`);
//     },
//     []
//   );

//   const handleRateNameOptionsReceived = useCallback(
//     (serviceIndex: number, options: any[], rateData: any[]) => {
//       setRateNameOptionsCache((prev) => {
//         // Only update if we don't have options or if they're different
//         const existingOptions = prev[serviceIndex];
//         const optionsChanged =
//           !existingOptions ||
//           existingOptions.length !== options.length ||
//           !options.every(
//             (opt, idx) => existingOptions[idx]?.value === opt.value
//           );

//         if (optionsChanged) {
//           console.log(
//             `✅ Cached rate name options for service index ${serviceIndex}:`,
//             options
//           );
//           return {
//             ...prev,
//             [serviceIndex]: options,
//           };
//         }

//         return prev;
//       });
//     },
//     []
//   );

//   // ============================================================================
//   // GET OPTIONS FOR SPECIFIC SERVICE
//   // ============================================================================
//   const getBasisTypeOptionsForService = useCallback(
//     (serviceIndex: number) => {
//       const config = serviceConfigs[serviceIndex];
//       if (!config || config.rateType !== "1") return [];

//       return basisTypeOptionsCache[config.rateType] || [];
//     },
//     [serviceConfigs, basisTypeOptionsCache]
//   );

//   const getRateNameOptionsForService = useCallback(
//     (serviceIndex: number) => {
//       return rateNameOptionsCache[serviceIndex] || [];
//     },
//     [rateNameOptionsCache]
//   );

//   // ============================================================================
//   // SHOW WHEN LOGIC (CONDITIONAL FIELD VISIBILITY)
//   // ============================================================================
//   const getFieldVisibility = useCallback(
//     (fieldName: string, formData: any, fieldPath?: string) => {
//       console.log("🔍 Checking visibility:", {
//         fieldName,
//         fieldPath,
//         formData,
//       });

//       // Always show service name (hidden field) and rate type
//       if (fieldName === "name" || fieldName === "rateType") {
//         return true;
//       }

//       const rateType = formData?.rateType || "";

//       // Show basis type only for variable rate (rateType = "1")
//       if (fieldName === "basisType") {
//         return rateType === "1";
//       }

//       // Show rate name only if:
//       // - For fixed rate (0): rateType is selected
//       // - For variable rate (1): both rateType and basisType are selected
//       if (fieldName === "rateName") {
//         if (rateType === "0") {
//           return true;
//         } else if (rateType === "1") {
//           const basisType = formData?.basisType || "";
//           return basisType !== "";
//         }
//         return false;
//       }

//       // Show average consumption always when a service is selected
//       if (fieldName === "avgConsumption") {
//         return true;
//       }

//       return true;
//     },
//     []
//   );

//   // ============================================================================
//   // FORM FIELD DEFINITION (USING FUNCTION-BASED itemFields)
//   // ============================================================================
//   const formFields = useMemo(() => {
//     return [
//       {
//         name: "selectedServices",
//         label: "Utility Services",
//         type: "multi-select" as const,
//         required: true,
//         fullWidth: true,
//         options: utilityServiceOptions,
//         placeholder: "Select utility services",
//         helperText: "Select one or more utility services to configure",
//         searchable: true,
//         clearable: true,
//         closeOnSelect: false,
//         group: "Service Selection",
//         groupOrder: 1,
//         classes: {
//           container: "w-full mb-6 col-span-2",
//           label: "block text-sm font-medium text-gray-700 mb-2",
//           select:
//             "w-full h-12 px-4 border border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors bg-white",
//         },
//       },
//       {
//         name: "services",
//         label: "Service Rate Configuration",
//         type: "form-array" as const,
//         required: false,
//         fullWidth: true,
//         minItems: 0,
//         showAddButton: false,
//         showRemoveButton: false,
//         showReorderButtons: false,
//         emptyMessage:
//           "Please select utility services above to configure their rates.",
//         helperText: "Configure rate details for each selected service",
//         // Dynamic item fields based on service index
//         itemFields: (index: number) => {
//           const config = serviceConfigs[index];
//           const basisTypeOptions = getBasisTypeOptionsForService(index);
//           const rateNameOptions = getRateNameOptionsForService(index);

//           return [
//             {
//               name: "name",
//               label: "Service Name",
//               type: "text" as const,
//               required: true,
//               disabled: true,
//               placeholder: "Service name",
//               helperText: "This service is auto-populated",
//               showWhen: (formData: any, fieldPath?: string) =>
//                 getFieldVisibility("name", formData, fieldPath),
//             },
//             {
//               name: "rateType",
//               label: "Rate Type",
//               type: "select" as const,
//               required: true,
//               placeholder: "Select rate type",
//               options: rateTypeOptions,
//               helperText: "Choose between fixed or variable rate",
//               showWhen: (formData: any, fieldPath?: string) =>
//                 getFieldVisibility("rateType", formData, fieldPath),
//             },
//             {
//               name: "basisType",
//               label: "Basis Type",
//               type: "select" as const,
//               required: false,
//               placeholder:
//                 basisTypeOptions.length > 0
//                   ? "Select basis type"
//                   : "Loading basis types...",
//               options: basisTypeOptions,
//               helperText: "Select the basis for variable rate calculation",
//               disabled: basisTypeOptions.length === 0,
//               showWhen: (formData: any, fieldPath?: string) =>
//                 getFieldVisibility("basisType", formData, fieldPath),
//             },
//             {
//               name: "rateName",
//               label: "Rate Name",
//               type: "select" as const,
//               required: true,
//               placeholder:
//                 rateNameOptions.length > 0
//                   ? "Select rate name"
//                   : "Select rate type first",
//               options: rateNameOptions,
//               helperText: "Choose the specific rate to apply",
//               disabled: rateNameOptions.length === 0,
//               showWhen: (formData: any, fieldPath?: string) => {
//                 const visible = getFieldVisibility(
//                   "rateName",
//                   formData,
//                   fieldPath
//                 );
//                 console.log(`🔍 RateName visibility for service ${index}:`, {
//                   visible,
//                   rateType: formData?.rateType,
//                   basisType: formData?.basisType,
//                   currentValue: formData?.rateName,
//                   availableOptions: rateNameOptions.length,
//                 });
//                 return visible;
//               },
//             },
//             {
//               name: "avgConsumption",
//               label: "Average Consumption",
//               type: "number" as const,
//               required: false,
//               placeholder: "0",
//               min: 0,
//               helperText: `Enter average consumption in ${
//                 utilityServices.find((s) => s.name === config?.serviceId)
//                   ?.unit || "units"
//               }`,
//               showWhen: (formData: any, fieldPath?: string) =>
//                 getFieldVisibility("avgConsumption", formData, fieldPath),
//             },
//           ];
//         },
//         classes: {
//           container: "w-full col-span-2",
//         },
//       },
//     ];
//   }, [
//     utilityServiceOptions,
//     rateTypeOptions,
//     serviceConfigs,
//     getBasisTypeOptionsForService,
//     getRateNameOptionsForService,
//     getFieldVisibility,
//     utilityServices,
//   ]);

//   // ============================================================================
//   // FORM INSTANCE CREATION
//   // ============================================================================
//   const form: UseFormReturn<any> = FormService.createForm({
//     fields: formFields,
//     defaultValues: {
//       selectedServices: [],
//       services: [],
//     },
//     mode: "onBlur",
//     layout: "vertical",
//   });

//   // ============================================================================
//   // POPULATE FORM WITH INITIAL DATA
//   // ============================================================================
//   useEffect(() => {
//     if (!isFormPopulated && Object.keys(transformedInitialData).length > 0) {
//       console.log(
//         "📝 Populating form with initial data:",
//         transformedInitialData
//       );

//       setTimeout(() => {
//         // Set selected services
//         if (
//           transformedInitialData.selectedServices &&
//           transformedInitialData.selectedServices.length > 0
//         ) {
//           form.setValue(
//             "selectedServices",
//             transformedInitialData.selectedServices
//           );
//           lastSelectedServicesRef.current = [
//             ...transformedInitialData.selectedServices,
//           ];
//         }

//         // Build services array from transformed data
//         const services: any[] = [];
//         const configs: Record<number, any> = {};
//         let index = 0;

//         while (transformedInitialData[`service_${index}_name`]) {
//           const serviceName = transformedInitialData[`service_${index}_name`];
//           const rateType =
//             transformedInitialData[`service_${index}_rateType`] || "";
//           const basisType =
//             transformedInitialData[`service_${index}_basisType`] || "";

//           services.push({
//             name: serviceName,
//             rateType: rateType,
//             basisType: basisType,
//             rateName: transformedInitialData[`service_${index}_rateName`] || "",
//             avgConsumption:
//               transformedInitialData[`service_${index}_avgConsumption`] || 0,
//           });

//           configs[index] = {
//             serviceId: serviceName,
//             rateType: rateType,
//             basisType: basisType,
//           };

//           index++;
//         }

//         if (services.length > 0) {
//           form.setValue("services", services);
//           setServiceConfigs(configs);
//         }

//         // If we have configs from transformedInitialData, use them
//         if (transformedInitialData.configs) {
//           setServiceConfigs(transformedInitialData.configs);
//         }

//         form.trigger();
//         setIsFormPopulated(true);

//         // Force a re-render to trigger fetchers for existing data
//         // This ensures rate name options are fetched for pre-filled values
//         setTimeout(() => {
//           setForceRender((prev) => prev + 1);
//         }, 100);
//       }, 100);
//     }
//   }, [isFormPopulated, transformedInitialData, form]);

//   // ============================================================================
//   // WATCH FOR SELECTED SERVICES CHANGES (FIXED - NO INFINITE LOOP)
//   // ============================================================================
//   useEffect(() => {
//     const subscription = form.watch((value, { name }) => {
//       if (name === "selectedServices" && !isUpdatingFormRef.current) {
//         const selectedServices = value.selectedServices || [];

//         // Compare with last known state to prevent infinite loop
//         const hasChanged =
//           selectedServices.length !== lastSelectedServicesRef.current.length ||
//           !selectedServices.every((s: string) =>
//             lastSelectedServicesRef.current.includes(s)
//           );

//         if (!hasChanged) {
//           console.log("🔄 Selected services unchanged, skipping update");
//           return;
//         }

//         console.log("🔄 Selected services changed:", selectedServices);
//         lastSelectedServicesRef.current = [...selectedServices];

//         // Prevent recursive updates
//         isUpdatingFormRef.current = true;

//         setTimeout(() => {
//           try {
//             // Build services array based on selection
//             const currentServices = form.getValues("services") || [];
//             const newServices: any[] = [];
//             const newConfigs: Record<number, any> = {};

//             selectedServices.forEach((serviceName: string, index: number) => {
//               // Check if service already exists in current services
//               const existingService = currentServices.find(
//                 (s: any) => s.name === serviceName
//               );

//               if (existingService) {
//                 // Keep existing service data
//                 newServices.push(existingService);
//                 newConfigs[index] = {
//                   serviceId: serviceName,
//                   rateType: existingService.rateType || "",
//                   basisType: existingService.basisType || "",
//                 };
//               } else {
//                 // Add new service with empty values
//                 newServices.push({
//                   name: serviceName,
//                   rateType: "",
//                   basisType: "",
//                   rateName: "",
//                   avgConsumption: 0,
//                 });
//                 newConfigs[index] = {
//                   serviceId: serviceName,
//                   rateType: "",
//                   basisType: "",
//                 };
//               }
//             });

//             form.setValue("services", newServices, { shouldValidate: false });
//             setServiceConfigs(newConfigs);
//           } finally {
//             // Reset flag after update completes
//             setTimeout(() => {
//               isUpdatingFormRef.current = false;
//             }, 50);
//           }
//         }, 0);
//       }
//     });

//     return () => subscription.unsubscribe();
//   }, [form]);

//   // Add this after handleReset function (around line 3083)
// // const handleFieldChange = useCallback(
// //   (fieldName: string, value: any) => {
// //     console.log(`🔄 Field changed: ${fieldName} =`, value);

// //     // Clear field errors if they exist
// //     if (FormService.getFieldError(form, fieldName)) {
// //       form.clearErrors(fieldName);
// //     }

// //     // Get all current form values
// //     const currentFormValues = form.getValues();

// //     // Create updated data with all form values
// //     const updatedData = {
// //       ...data,
// //       ...currentFormValues,
// //       [fieldName]: value,
// //     };

// //     console.log("💾 Saving to localStorage:", updatedData);
    
// //     // Save to localStorage via parent handlers
// //     onDataChange?.(updatedData);
// //     stepChange?.(updatedData);
// //   },
// //   [data, onDataChange, stepChange, form]
// // );
//   // ============================================================================
//   // WATCH FOR RATE TYPE AND BASIS TYPE CHANGES
//   // ============================================================================
//   useEffect(() => {
//     const subscription = form.watch((value, { name }) => {
//       if (
//         name &&
//         name.includes("services.") &&
//         (name.includes(".rateType") || name.includes(".basisType")) &&
//         !isUpdatingFormRef.current
//       ) {
//         const match = name.match(/services\.(\d+)\.(rateType|basisType)/);
//         if (match) {
//           const serviceIndex = parseInt(match[1], 10);
//           const fieldChanged = match[2];
//           const services = value.services || [];
//           const currentService = services[serviceIndex];

//           if (currentService) {
//             const newRateType = currentService.rateType || "";
//             const newBasisType = currentService.basisType || "";

//             console.log(`🔄 Service ${serviceIndex} ${fieldChanged} changed:`, {
//               rateType: newRateType,
//               basisType: newBasisType,
//             });

//             // Prevent recursive updates
//             isUpdatingFormRef.current = true;

//             setTimeout(() => {
//               try {
//                 // Update service configs
//                 setServiceConfigs((prev) => ({
//                   ...prev,
//                   [serviceIndex]: {
//                     serviceId: currentService.name,
//                     rateType: newRateType,
//                     basisType: newBasisType,
//                   },
//                 }));

//                 // Clear rate name when rate type or basis type changes
//                 if (fieldChanged === "rateType") {
//                   form.setValue(`services.${serviceIndex}.rateName`, "", {
//                     shouldValidate: false,
//                   });
//                   form.setValue(`services.${serviceIndex}.basisType`, "", {
//                     shouldValidate: false,
//                   });

//                   // Clear rate name cache for this service
//                   setRateNameOptionsCache((prev) => {
//                     const newCache = { ...prev };
//                     delete newCache[serviceIndex];
//                     return newCache;
//                   });
//                 } else if (fieldChanged === "basisType") {
//                   form.setValue(`services.${serviceIndex}.rateName`, "", {
//                     shouldValidate: false,
//                   });

//                   // Clear rate name cache for this service
//                   setRateNameOptionsCache((prev) => {
//                     const newCache = { ...prev };
//                     delete newCache[serviceIndex];
//                     return newCache;
//                   });
//                 }

//                 // Force re-render to update field visibility
//                 setForceRender((prev) => prev + 1);
//               } finally {
//                 setTimeout(() => {
//                   isUpdatingFormRef.current = false;
//                 }, 50);
//               }
//             }, 0);
//           }
//         }
//       }
//     });

//     return () => subscription.unsubscribe();
//   }, [form]);

//   // ============================================================================
//   // DETERMINE WHICH FETCHERS TO RENDER
//   // ============================================================================
//   const fetchersData = useMemo(() => {
//     const result: Array<{
//       serviceIndex: number;
//       serviceId: string;
//       rateType: string;
//       basisType: string;
//       basisTypeValue: string;
//       needsBasisTypeFetch: boolean;
//       needsRateNameFetch: boolean;
//     }> = [];

//     Object.entries(serviceConfigs).forEach(([indexStr, config]) => {
//       const serviceIndex = parseInt(indexStr, 10);
//       const { serviceId, rateType, basisType } = config;

//       if (!rateType) return;

//       // Determine if we need to fetch basis types
//       const needsBasisTypeFetch =
//         rateType === "1" && !basisTypeOptionsCache[rateType];

//       // Determine if we need to fetch rate names
//       let needsRateNameFetch = false;
//       let basisTypeValue = "";

//       if (rateType === "0") {
//         // Fixed rate: always fetch if not cached
//         // This ensures options are loaded even when coming from navigation
//         needsRateNameFetch = !rateNameOptionsCache[serviceIndex];
//         console.log(
//           `🔍 Fixed rate check for service ${serviceIndex}: needs fetch = ${needsRateNameFetch}, cached = ${!!rateNameOptionsCache[
//             serviceIndex
//           ]}`
//         );
//       } else if (rateType === "1") {
//         // Variable rate: need basis type first
//         if (basisType) {
//           const basisTypeOption = basisTypeOptionsCache[rateType]?.find(
//             (opt) => String(opt.value) === String(basisType)
//           );
//           basisTypeValue = basisTypeOption?.label || "";

//           // Fetch if we have basisTypeValue and not cached
//           needsRateNameFetch =
//             !!basisTypeValue && !rateNameOptionsCache[serviceIndex];
//           console.log(
//             `🔍 Variable rate check for service ${serviceIndex}: basisTypeValue = ${basisTypeValue}, needs fetch = ${needsRateNameFetch}, cached = ${!!rateNameOptionsCache[
//               serviceIndex
//             ]}`
//           );
//         }
//       }

//       result.push({
//         serviceIndex,
//         serviceId,
//         rateType,
//         basisType,
//         basisTypeValue,
//         needsBasisTypeFetch,
//         needsRateNameFetch,
//       });
//     });

//     console.log("📊 Fetchers data computed:", result);
//     return result;
//   }, [
//     serviceConfigs,
//     basisTypeOptionsCache,
//     rateNameOptionsCache,
//     forceRender,
//   ]);

//   // ============================================================================
//   // HANDLE FORM SUBMISSION
//   // ============================================================================
//   // const handleSubmit = async (formData: any) => {
//   //   console.log("📤 Submitting form data:", formData);

//   //   try {
//   //     clearValidationError?.();

//   //     // Validate that all services have required fields
//   //     const services = formData.services || [];
//   //     const selectedServices = formData.selectedServices || [];

//   //     if (selectedServices.length === 0) {
//   //       setValidationError?.("Please select at least one utility service");
//   //       return;
//   //     }

//   //     // Validate each service
//   //     for (let i = 0; i < services.length; i++) {
//   //       const service = services[i];

//   //       if (!service.rateType) {
//   //         setValidationError?.(`Please select rate type for ${service.name}`);
//   //         return;
//   //       }

//   //       if (service.rateType === "1" && !service.basisType) {
//   //         setValidationError?.(`Please select basis type for ${service.name}`);
//   //         return;
//   //       }

//   //       if (!service.rateName) {
//   //         setValidationError?.(`Please select rate name for ${service.name}`);
//   //         return;
//   //       }
//   //     }

//   //     // Transform to API payload (snake_case)
//   //     const utilityServiceData: Record<string, any> = {};
//   //     const utilityServiceDataForParent: Record<string, any> = {};

//   //     services.forEach((service: any) => {
//   //       // API payload format (snake_case)
//   //       utilityServiceData[service.name] = {
//   //         type: parseInt(service.rateType),
//   //         basis: service.rateType === "1" ? parseInt(service.basisType) : null,
//   //         rate: service.rateName,
//   //         avg_consumption: service.avgConsumption || 0,
//   //       };

//   //       // Also store in format for parent component (for stepper navigation)
//   //       utilityServiceDataForParent[service.name] = {
//   //         rateType: service.rateType,
//   //         basisType: service.basisType,
//   //         rateName: service.rateName,
//   //         avgConsumption: service.avgConsumption || 0,
//   //       };
//   //     });

//   //     const payload = {
//   //       utility_service: selectedServices,
//   //       utility_service_data: {
//   //         rate: utilityServiceData,
//   //       },
//   //       current_step: 3,
//   //       remote_utility_id: utilityId,
//   //     };

//   //     console.log("🚀 Submitting Step 3 Payload:", payload);

//   //     await updatePlanMutation.mutateAsync(payload);

//   //     // Update parent data with both formats
//   //     onDataChange?.({
//   //       utilityService: selectedServices,
//   //       rateData: utilityServiceData,
//   //       selectedServices: selectedServices,
//   //       utility_service_data: utilityServiceDataForParent,
//   //     });
//   //     stepChange?.({
//   //       utilityService: selectedServices,
//   //       rateData: utilityServiceData,
//   //       selectedServices: selectedServices,
//   //       utility_service_data: utilityServiceDataForParent,
//   //     });

//   //     onNext?.();
//   //   } catch (error) {
//   //     console.error("❌ Submission failed", error);
//   //     setValidationError?.("An error occurred while saving. Please try again.");
//   //   }
//   // };

// const handleSubmit = async (data: any) => {
//   console.log("Submitting form data:", data);

//   try {
//     // validate form via FormService helper if available
//     const isValid = await FormService.validateForm(form);
//     if (!isValid) return;

//     // Use current form values to compute payload parts
//     const formValues = form.getValues();
//     const selectedServices: string[] = formValues.selectedServices || [];
//     const services: any[] = formValues.services || [];

//     // Build utilityServiceData for API and a parent-friendly structure
//     const utilityServiceData: Record<string, any> = {};
//     const utilityServiceDataForParent: Record<string, any> = {};

//     services.forEach((service: any) => {
//       const name = service.name;
//       utilityServiceData[name] = {
//         type: service.rateType ? parseInt(service.rateType, 10) : null,
//         basis: service.rateType === "1" ? (service.basisType ? parseInt(service.basisType, 10) : null) : null,
//         rate: service.rateName,
//         avg_consumption: service.avgConsumption || 0,
//       };

//       utilityServiceDataForParent[name] = {
//         rateType: service.rateType,
//         basisType: service.basisType,
//         rateName: service.rateName,
//         avgConsumption: service.avgConsumption || 0,
//       };
//     });

//     // Create API payload
//     const payload = {
//       utility_service: selectedServices,
//       utility_service_data: {
//         rate: utilityServiceData,
//       },
//       current_step: 3,
//       remote_utility_id: utilityId,
//     };

//     console.log("🧾 Form payload:", payload);

//     // Call update plan mutation
//     await updatePlanMutation.mutateAsync(payload);

//     // Update localStorage (step index 2) safely
//     const planSpecificKey = `utility-plan-progress-${planId}`;

//     try {
//       const storedData =
//         localStorage.getItem(planSpecificKey) ||
//         localStorage.getItem("utility-plan-progress");

//       if (storedData) {
//         const parsed = JSON.parse(storedData);

//         // Update stepData[2] with latest utility service info
//         parsed.stepData = {
//           ...parsed.stepData,
//           2: {
//             ...(parsed.stepData?.[2] || {}),
//             utility_service: selectedServices,
//             rateData: utilityServiceData,
//             selectedServices,
//             utility_service_data: utilityServiceDataForParent,
//           },
//         };

//         // Optional: update timestamp
//         parsed.timestamp = Date.now();

//         // Save updated data
//         localStorage.setItem(planSpecificKey, JSON.stringify(parsed));
//         localStorage.setItem("utility-plan-progress", JSON.stringify(parsed));

//         console.log("🧠 LocalStorage step[2] updated:", parsed.stepData[2]);
//       }
//     } catch (error) {
//       console.error("⚠️ Failed to update localStorage step data:", error);
//     }

//     // Trigger parent handlers with computed values
//     onDataChange?.({
//       utilityService: selectedServices,
//       rateData: utilityServiceData,
//       selectedServices,
//       utility_service_data: utilityServiceDataForParent,
//     });

//     stepChange?.({
//       utilityService: selectedServices,
//       rateData: utilityServiceData,
//       selectedServices,
//       utility_service_data: utilityServiceDataForParent,
//     });

//     // Move to next step
//     onNext?.();
//   } catch (error: any) {
//     console.error("❌ Error in handleSubmit:", error);
//     setValidationError?.("An error occurred while saving. Please try again.");
//   }
// };



//   const handleReset = () => {
//     form.reset();
//     setServiceConfigs({});
//     setRateNameOptionsCache({});
//     setBasisTypeOptionsCache({});
//     setIsFormPopulated(false);
//     lastSelectedServicesRef.current = [];
//   };

//   // ============================================================================
//   // RESET FORM POPULATED FLAG WHEN DATA CHANGES (FOR STEPPER NAVIGATION)
//   // ============================================================================
//   useEffect(() => {
//     // When navigating via stepper, reset the populated flag to allow re-population
//     if (data && Object.keys(data).length > 0) {
//       setIsFormPopulated(false);
//     }
//   }, [data]);

//   // ============================================================================
//   // CUSTOM FOOTER RENDERING
//   // ============================================================================
//   const renderCustomFooter = useCallback(
//     () => (
//       <div className="space-y-4">
//         {loadingUtilityServices && (
//           <div className="p-4 bg-blue-50 border border-blue-200 rounded-md">
//             <div className="flex items-center space-x-2">
//               <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
//               <span className="text-sm text-blue-800">
//                 Loading utility services...
//               </span>
//             </div>
//           </div>
//         )}

//         {!loadingUtilityServices && utilityServices.length === 0 && (
//           <div className="p-4 bg-red-50 border border-red-200 rounded-md">
//             <div className="flex items-start">
//               <Info className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
//               <div>
//                 <h4 className="text-sm font-medium text-red-800">
//                   No Utility Services Available
//                 </h4>
//                 <p className="mt-1 text-sm text-red-700">
//                   No active utility services found. Please configure utility
//                   services first.
//                 </p>
//               </div>
//             </div>
//           </div>
//         )}

//         {!loadingUtilityServices &&
//           utilityServices.length > 0 &&
//           form.watch("selectedServices")?.length === 0 && (
//             <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-md">
//               <div className="flex items-start">
//                 <Info className="w-5 h-5 text-yellow-500 mt-0.5 mr-3 flex-shrink-0" />
//                 <div>
//                   <h4 className="text-sm font-medium text-yellow-800">
//                     No Services Selected
//                   </h4>
//                   <p className="mt-1 text-sm text-yellow-700">
//                     Please select at least one utility service to configure
//                     rates.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           )}

//         <div className="flex justify-between pt-6 border-t border-gray-200">
//           <button
//             type="button"
//             onClick={onPrevious}
//             disabled={isFirstStep}
//             className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-200 transition-colors"
//           >
//             <ChevronLeft className="inline w-4 h-4 mr-1" />
//             Previous
//           </button>

//           <button
//             type="submit"
//             disabled={
//               loadingUtilityServices ||
//               utilityServices.length === 0 ||
//               form.watch("selectedServices")?.length === 0
//             }
//             className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//           >
//             Next
//             <ChevronRight className="inline w-4 h-4 ml-1" />
//           </button>
//         </div>
//       </div>
//     ),
//     [isFirstStep, onPrevious, loadingUtilityServices, utilityServices, form]
//   );

//   // ============================================================================
//   // LOADING STATE
//   // ============================================================================
//   if (loadingUtilityServices) {
//     return (
//       <div className="space-y-6">
//         <div className="p-8 text-center">
//           <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
//           <p className="text-gray-600">Loading utility services...</p>
//         </div>
//       </div>
//     );
//   }

//   // ============================================================================
//   // MAIN RENDER
//   // ============================================================================
//   return (
//     <div className="space-y-6">
//       {/* Render Basis Type Fetchers */}
//       {fetchersData
//         .filter((d) => d.needsBasisTypeFetch)
//         .map(({ rateType }) => (
//           <BasisTypeFetcher
//             key={`basis-${rateType}-${forceRender}`}
//             rateTypeKey={rateType}
//             onDataReceived={handleBasisTypeOptionsReceived}
//           />
//         ))}

//       {/* Render Rate Name Fetchers */}
//       {fetchersData
//         .filter((d) => d.needsRateNameFetch)
//         .map(({ serviceIndex, serviceId, rateType, basisTypeValue }) => (
//           <RateNameFetcher
//             key={`rate-${serviceIndex}-${rateType}-${basisTypeValue}-${forceRender}`}
//             serviceId={serviceId}
//             serviceIndex={serviceIndex}
//             rateTypeKey={rateType}
//             basisTypeValue={basisTypeValue}
//             onDataReceived={handleRateNameOptionsReceived}
//           />
//         ))}

//       {/* Add Tariff Button */}
//       <Button size="sm" onClick={() => navigate("/plan-tarrif/tariff/add")}>
//         <Plus className="h-4 w-4" /> Add New Tariff
//       </Button>

//       {/* Dynamic Form */}
//       <DynamicForm
//         fields={formFields}
//         form={form}
//         onSubmit={handleSubmit}
//         onReset={handleReset}
//   // onFieldChange={handleFieldChange}  // ⬅️ ADD THIS LINE
//         loading={loadingUtilityServices}
//         gridColumns={2}
//         responsiveColumns={{
//           sm: 1,
//           md: 2,
//         }}
//         config={{
//           showProgress: false,
//           layout: "vertical",
//           spacing: "none",
//           submitButtonText: "Next",
//           showResetButton: false,
//           resetOnSubmit: false,
//           classes: {
//             form: "space-y-0",
//             fieldContainer: "",
//             buttonContainer: "hidden",
//             fieldGroup: "",
//           },
//         }}
//         renderCustomFooter={renderCustomFooter}
//         className=""
//         style={{
//           background: "transparent",
//           border: "none",
//           boxShadow: "none",
//         }}
//       />
//     </div>
//   );
// };

// export default UtilityServicesStep;


// Key fixes:
// 1. Enhanced transformedInitialData to handle ALL data structures properly
// 2. Fixed form population to restore avgConsumption correctly
// 3. Added proper localStorage sync in handleSubmit
// 4. Reset isFormPopulated when data changes to allow repopulation

import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from "react";
import { ChevronLeft, ChevronRight, Info, Plus } from "lucide-react";
import { FormService } from "@shared/services/FormServices";
import { DynamicForm } from "@shared/components/DynamicForm";
import { UseFormReturn } from "react-hook-form";
import { useActiveUtilityServices } from "@shared/hooks/useActiveUtililyServices";
import {
  useBasisTypeOptions,
  useRateNameOptions,
  useRateTypeOptions,
  useUpdatePlanMutation,
} from "@features/onboarding/utility-setup/hooks";
import { useNavigate, useParams } from "react-router-dom";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { Button } from "@shared/ui/button";

interface UtilityServicesStepProps {
  onNext?: () => void;
  onPrevious?: () => void;
  isFirstStep?: boolean;
  isLastStep?: boolean;
  currentStepIndex?: number;
  totalSteps?: number;
  data?: any;
  onDataChange?: (data: any) => void;
  setValidationError?: (error: string) => void;
  clearValidationError?: () => void;
  stepChange?: (data: any) => void;
}

const UtilityServicesStep: React.FC<UtilityServicesStepProps> = ({
  onNext,
  onPrevious,
  isFirstStep,
  isLastStep,
  currentStepIndex = 2,
  totalSteps = 4,
  data = {},
  onDataChange,
  setValidationError,
  clearValidationError,
  stepChange,
}) => {
  console.log(
    "🚀 UtilityServicesStep rendered with data:",
    JSON.stringify(data, null, 2)
  );

  // ============================================================================
  // STATE MANAGEMENT
  // ============================================================================
  const [isFormPopulated, setIsFormPopulated] = useState(false);
  const [serviceConfigs, setServiceConfigs] = useState<
    Record<number, { rateType: string; basisType: string; serviceId: string }>
  >({});
  const [forceRender, setForceRender] = useState(0);

  // Refs to prevent infinite loops
  const isUpdatingFormRef = useRef(false);
  const lastSelectedServicesRef = useRef<string[]>([]);
  const lastDataRef = useRef<any>(null);

  // ============================================================================
  // HOOKS & API
  // ============================================================================
  const { planId, action } = useParams<{ planId?: string; action: string }>();
  const parsedPlanId = planId ? Number(planId) : null;
  const utilityId = useRemoteUtilityId();
  const updatePlanMutation = useUpdatePlanMutation(parsedPlanId);
  const navigate = useNavigate();

  const { data: activeUtilityServices, isLoading: loadingUtilityServices } =
    useActiveUtilityServices();
  const { data: rateTypes } = useRateTypeOptions();

  // ============================================================================
  // UTILITY SERVICES PROCESSING
  // ============================================================================
  const utilityServices = useMemo(() => {
    if (!activeUtilityServices || activeUtilityServices.length === 0) {
      return [];
    }

    return activeUtilityServices.map((service) => ({
      id: service.name,
      name: service.name,
      unit: service.utilityUnit || "units",
      originalId: service.id,
      ...service,
    }));
  }, [activeUtilityServices]);

  const rateTypeOptions = useMemo(() => {
    return (
      rateTypes?.map((item) => ({
        label: item.value,
        value: item.key,
      })) ?? []
    );
  }, [rateTypes]);

  const utilityServiceOptions = useMemo(() => {
    return utilityServices.map((service) => ({
      value: service.name,
      label: service.name,
    }));
  }, [utilityServices]);

  // ============================================================================
  // ENHANCED TRANSFORM INITIAL DATA - HANDLES ALL STRUCTURES
  // ============================================================================
  const transformedInitialData = useMemo(() => {
    console.log("🔧 Transforming initial data:", data);

    const result: any = {
      selectedServices: [],
    };

    // PRIORITY 1: Handle rateData structure (from API or localStorage)
    if (
      data.utilityService &&
      data.rateData &&
      Object.keys(data.rateData).length > 0
    ) {
      console.log("📦 Processing rateData structure");
      result.selectedServices = Array.isArray(data.utilityService)
        ? data.utilityService
        : [data.utilityService];

      const configs: Record<number, any> = {};
      let index = 0;

      Object.keys(data.rateData).forEach((serviceId) => {
        const rateInfo = data.rateData[serviceId];
        const rateType = rateInfo.type?.toString() || "";
        const basisType =
          rateInfo.type === 1 &&
          rateInfo.basis !== null &&
          rateInfo.basis !== undefined
            ? rateInfo.basis?.toString() || ""
            : "";

        configs[index] = {
          serviceId,
          rateType,
          basisType,
        };

        result[`service_${index}_name`] = serviceId;
        result[`service_${index}_rateType`] = rateType;
        result[`service_${index}_basisType`] = basisType;
        result[`service_${index}_rateName`] = rateInfo.rate || "";
        // FIXED: Handle both snake_case and camelCase
        result[`service_${index}_avgConsumption`] =
          rateInfo.avgConsumption || rateInfo.avg_consumption || 0;

        index++;
      });

      return { ...result, configs };
    }

    // PRIORITY 2: Handle utility_service_data structure (from parent state)
    if (
      data.selectedServices &&
      Array.isArray(data.selectedServices) &&
      data.utility_service_data
    ) {
      console.log("📦 Processing utility_service_data from parent");
      result.selectedServices = data.selectedServices;

      const configs: Record<number, any> = {};

      data.selectedServices.forEach((serviceName: string, index: number) => {
        const serviceData = data.utility_service_data[serviceName];
        if (serviceData) {
          const rateType = serviceData.rateType || "";
          const basisType = serviceData.basisType || "";

          configs[index] = {
            serviceId: serviceName,
            rateType,
            basisType,
          };

          result[`service_${index}_name`] = serviceName;
          result[`service_${index}_rateType`] = rateType;
          result[`service_${index}_basisType`] = basisType;
          result[`service_${index}_rateName`] = serviceData.rateName || "";
          result[`service_${index}_avgConsumption`] =
            serviceData.avgConsumption || 0;
        }
      });

      return { ...result, configs };
    }

    // PRIORITY 3: Handle utility_configurations structure (from API response)
    if (
      data.utility_configurations &&
      Array.isArray(data.utility_configurations)
    ) {
      console.log("📦 Processing utility_configurations structure");

      result.selectedServices = data.utility_configurations.map(
        (config: any) => config.serviceName
      );

      const configs: Record<number, any> = {};

      data.utility_configurations.forEach((config: any, index: number) => {
        const serviceName = config.serviceName;
        const rateType = config.rateType || "";
        const basisType = config.basisType || "";

        configs[index] = {
          serviceId: serviceName,
          rateType,
          basisType,
        };

        result[`service_${index}_name`] = serviceName;
        result[`service_${index}_rateType`] = rateType;
        result[`service_${index}_basisType`] = basisType;
        result[`service_${index}_rateName`] = config.rateName || "";
        result[`service_${index}_avgConsumption`] = config.avgConsumption || 0;
      });

      return { ...result, configs };
    }

    // FALLBACK: Just selectedServices
    if (data.selectedServices && Array.isArray(data.selectedServices)) {
      console.log("📦 Processing minimal selectedServices");
      result.selectedServices = data.selectedServices;
    }

    console.log("📦 Transformed result:", result);
    return result;
  }, [data]);

  // ============================================================================
  // BASIS TYPE FETCHER COMPONENT
  // ============================================================================
  const BasisTypeFetcher = ({
    rateTypeKey,
    onDataReceived,
  }: {
    rateTypeKey: string;
    onDataReceived: (rateType: string, options: any[]) => void;
  }) => {
    const { data: basisTypes = [], isLoading } =
      useBasisTypeOptions(rateTypeKey);

    useEffect(() => {
      if (!isLoading && basisTypes.length > 0) {
        const options = basisTypes.map((sc: any) => ({
          label: sc.value,
          value: sc.key,
        }));
        console.log(
          `🔄 Fetched basis types for rateType=${rateTypeKey}:`,
          options
        );
        onDataReceived(rateTypeKey, options);
      }
    }, [basisTypes, isLoading, rateTypeKey, onDataReceived]);

    return null;
  };

  // ============================================================================
  // RATE NAME FETCHER COMPONENT
  // ============================================================================
  const RateNameFetcher = ({
    serviceId,
    serviceIndex,
    rateTypeKey,
    basisTypeValue,
    onDataReceived,
  }: {
    serviceId: string;
    serviceIndex: number;
    rateTypeKey: string;
    basisTypeValue?: string;
    onDataReceived: (
      serviceIndex: number,
      options: any[],
      rateData: any[]
    ) => void;
  }) => {
    const queryParams = useMemo(() => {
      if (rateTypeKey === "0") {
        return {
          type: "rate_type",
          value: rateTypeKey,
          utilityService: serviceId,
        };
      } else if (rateTypeKey === "1" && basisTypeValue) {
        return {
          type: "basis_type",
          value: basisTypeValue,
          utilityService: serviceId,
        };
      }
      return null;
    }, [rateTypeKey, basisTypeValue, serviceId]);

    const { data: rateNames = [], isLoading } = useRateNameOptions(queryParams);
    const rateNamesArray = rateNames as any[];

    useEffect(() => {
      if (!isLoading && rateNamesArray.length > 0 && queryParams) {
        const options = rateNamesArray.map((sc: any) => ({
          label: sc.rateName,
          value: sc.id,
        }));
        console.log(
          `🔄 Fetched rate names for service ${serviceId} (index ${serviceIndex}):`,
          options
        );
        onDataReceived(serviceIndex, options, rateNamesArray);
      }
    }, [rateNamesArray, isLoading, queryParams, onDataReceived, serviceIndex]);

    return null;
  };

  // ============================================================================
  // OPTION CACHES FOR DROPDOWNS
  // ============================================================================
  const [basisTypeOptionsCache, setBasisTypeOptionsCache] = useState<
    Record<string, any[]>
  >({});
  const [rateNameOptionsCache, setRateNameOptionsCache] = useState<
    Record<number, any[]>
  >({});

  const handleBasisTypeOptionsReceived = useCallback(
    (rateType: string, options: any[]) => {
      setBasisTypeOptionsCache((prev) => ({
        ...prev,
        [rateType]: options,
      }));
      console.log(`✅ Cached basis type options for ${rateType}`);
    },
    []
  );

  const handleRateNameOptionsReceived = useCallback(
    (serviceIndex: number, options: any[], rateData: any[]) => {
      setRateNameOptionsCache((prev) => {
        const existingOptions = prev[serviceIndex];
        const optionsChanged =
          !existingOptions ||
          existingOptions.length !== options.length ||
          !options.every(
            (opt, idx) => existingOptions[idx]?.value === opt.value
          );

        if (optionsChanged) {
          console.log(
            `✅ Cached rate name options for service index ${serviceIndex}:`,
            options
          );
          return {
            ...prev,
            [serviceIndex]: options,
          };
        }

        return prev;
      });
    },
    []
  );

  // ============================================================================
  // GET OPTIONS FOR SPECIFIC SERVICE
  // ============================================================================
  const getBasisTypeOptionsForService = useCallback(
    (serviceIndex: number) => {
      const config = serviceConfigs[serviceIndex];
      if (!config || config.rateType !== "1") return [];

      return basisTypeOptionsCache[config.rateType] || [];
    },
    [serviceConfigs, basisTypeOptionsCache]
  );

  const getRateNameOptionsForService = useCallback(
    (serviceIndex: number) => {
      return rateNameOptionsCache[serviceIndex] || [];
    },
    [rateNameOptionsCache]
  );

  // ============================================================================
  // SHOW WHEN LOGIC (CONDITIONAL FIELD VISIBILITY)
  // ============================================================================
  const getFieldVisibility = useCallback(
    (fieldName: string, formData: any, fieldPath?: string) => {
      if (fieldName === "name" || fieldName === "rateType") {
        return true;
      }

      const rateType = formData?.rateType || "";

      if (fieldName === "basisType") {
        return rateType === "1";
      }

      if (fieldName === "rateName") {
        if (rateType === "0") {
          return true;
        } else if (rateType === "1") {
          const basisType = formData?.basisType || "";
          return basisType !== "";
        }
        return false;
      }

      if (fieldName === "avgConsumption") {
        return true;
      }

      return true;
    },
    []
  );

  // ============================================================================
  // FORM FIELD DEFINITION
  // ============================================================================
  const formFields = useMemo(() => {
    return [
      {
        name: "selectedServices",
        label: "Utility Services",
        type: "multi-select" as const,
        required: true,
        fullWidth: true,
        options: utilityServiceOptions,
        placeholder: "Select utility services",
        helperText: "Select one or more utility services to configure",
        searchable: true,
        clearable: true,
        closeOnSelect: false,
        group: "Service Selection",
        groupOrder: 1,
        classes: {
          container: "w-full mb-6 col-span-2",
          label: "block text-sm font-medium text-gray-700 mb-2",
          select:
            "w-full h-12 px-4 border border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors bg-white",
        },
      },
      {
        name: "services",
        label: "Service Rate Configuration",
        type: "form-array" as const,
        required: false,
        fullWidth: true,
        minItems: 0,
        showAddButton: false,
        showRemoveButton: false,
        showReorderButtons: false,
        emptyMessage:
          "Please select utility services above to configure their rates.",
        helperText: "Configure rate details for each selected service",
        itemFields: (index: number) => {
          const config = serviceConfigs[index];
          const basisTypeOptions = getBasisTypeOptionsForService(index);
          const rateNameOptions = getRateNameOptionsForService(index);

          return [
            {
              name: "name",
              label: "Service Name",
              type: "text" as const,
              required: true,
              disabled: true,
              placeholder: "Service name",
              helperText: "This service is auto-populated",
              showWhen: (formData: any, fieldPath?: string) =>
                getFieldVisibility("name", formData, fieldPath),
            },
            {
              name: "rateType",
              label: "Rate Type",
              type: "select" as const,
              required: true,
              placeholder: "Select rate type",
              options: rateTypeOptions,
              helperText: "Choose between fixed or variable rate",
              showWhen: (formData: any, fieldPath?: string) =>
                getFieldVisibility("rateType", formData, fieldPath),
            },
            {
              name: "basisType",
              label: "Basis Type",
              type: "select" as const,
              required: false,
              placeholder:
                basisTypeOptions.length > 0
                  ? "Select basis type"
                  : "Loading basis types...",
              options: basisTypeOptions,
              helperText: "Select the basis for variable rate calculation",
              disabled: basisTypeOptions.length === 0,
              showWhen: (formData: any, fieldPath?: string) =>
                getFieldVisibility("basisType", formData, fieldPath),
            },
            {
              name: "rateName",
              label: "Rate Name",
              type: "select" as const,
              required: true,
              placeholder:
                rateNameOptions.length > 0
                  ? "Select rate name"
                  : "Select rate type first",
              options: rateNameOptions,
              helperText: "Choose the specific rate to apply",
              disabled: rateNameOptions.length === 0,
              showWhen: (formData: any, fieldPath?: string) =>
                getFieldVisibility("rateName", formData, fieldPath),
            },
            {
              name: "avgConsumption",
              label: "Average Consumption",
              type: "number" as const,
              required: false,
              placeholder: "0",
              min: 0,
              helperText: `Enter average consumption in ${
                utilityServices.find((s) => s.name === config?.serviceId)
                  ?.unit || "units"
              }`,
              showWhen: (formData: any, fieldPath?: string) =>
                getFieldVisibility("avgConsumption", formData, fieldPath),
            },
          ];
        },
        classes: {
          container: "w-full col-span-2",
        },
      },
    ];
  }, [
    utilityServiceOptions,
    rateTypeOptions,
    serviceConfigs,
    getBasisTypeOptionsForService,
    getRateNameOptionsForService,
    getFieldVisibility,
    utilityServices,
  ]);

  // ============================================================================
  // FORM INSTANCE CREATION
  // ============================================================================
  const form: UseFormReturn<any> = FormService.createForm({
    fields: formFields,
    defaultValues: {
      selectedServices: [],
      services: [],
    },
    mode: "onBlur",
    layout: "vertical",
  });

  // ============================================================================
  // POPULATE FORM WITH INITIAL DATA - FIXED VERSION
  // ============================================================================
  useEffect(() => {
    if (!isFormPopulated && Object.keys(transformedInitialData).length > 0) {
      console.log(
        "📝 Populating form with initial data:",
        transformedInitialData
      );

      setTimeout(() => {
        // Set selected services
        if (
          transformedInitialData.selectedServices &&
          transformedInitialData.selectedServices.length > 0
        ) {
          form.setValue(
            "selectedServices",
            transformedInitialData.selectedServices,
            { shouldValidate: false }
          );
          lastSelectedServicesRef.current = [
            ...transformedInitialData.selectedServices,
          ];
        }

        // Build services array from transformed data
        const services: any[] = [];
        const configs: Record<number, any> = {};
        let index = 0;

        while (transformedInitialData[`service_${index}_name`]) {
          const serviceName = transformedInitialData[`service_${index}_name`];
          const rateType =
            transformedInitialData[`service_${index}_rateType`] || "";
          const basisType =
            transformedInitialData[`service_${index}_basisType`] || "";
          const rateName =
            transformedInitialData[`service_${index}_rateName`] || "";
          const avgConsumption =
            transformedInitialData[`service_${index}_avgConsumption`] || 0;

          console.log(
            `📝 Populating service ${index}:`,
            { serviceName, rateType, basisType, rateName, avgConsumption }
          );

          services.push({
            name: serviceName,
            rateType: rateType,
            basisType: basisType,
            rateName: rateName,
            avgConsumption: avgConsumption,
          });

          configs[index] = {
            serviceId: serviceName,
            rateType: rateType,
            basisType: basisType,
          };

          index++;
        }

        if (services.length > 0) {
          console.log("📝 Setting services array:", services);
          form.setValue("services", services, { shouldValidate: false });
          setServiceConfigs(configs);
        }

        // If we have configs from transformedInitialData, use them
        if (transformedInitialData.configs) {
          setServiceConfigs(transformedInitialData.configs);
        }

        form.trigger();
        setIsFormPopulated(true);

        // Force a re-render to trigger fetchers for existing data
        setTimeout(() => {
          setForceRender((prev) => prev + 1);
        }, 100);
      }, 100);
    }
  }, [isFormPopulated, transformedInitialData, form]);

  // ============================================================================
  // WATCH FOR SELECTED SERVICES CHANGES
  // ============================================================================
  useEffect(() => {
    const subscription = form.watch((value, { name }) => {
      if (name === "selectedServices" && !isUpdatingFormRef.current) {
        const selectedServices = value.selectedServices || [];

        const hasChanged =
          selectedServices.length !== lastSelectedServicesRef.current.length ||
          !selectedServices.every((s: string) =>
            lastSelectedServicesRef.current.includes(s)
          );

        if (!hasChanged) {
          return;
        }

        console.log("🔄 Selected services changed:", selectedServices);
        lastSelectedServicesRef.current = [...selectedServices];

        isUpdatingFormRef.current = true;

        setTimeout(() => {
          try {
            const currentServices = form.getValues("services") || [];
            const newServices: any[] = [];
            const newConfigs: Record<number, any> = {};

            selectedServices.forEach((serviceName: string, index: number) => {
              const existingService = currentServices.find(
                (s: any) => s.name === serviceName
              );

              if (existingService) {
                newServices.push(existingService);
                newConfigs[index] = {
                  serviceId: serviceName,
                  rateType: existingService.rateType || "",
                  basisType: existingService.basisType || "",
                };
              } else {
                newServices.push({
                  name: serviceName,
                  rateType: "",
                  basisType: "",
                  rateName: "",
                  avgConsumption: 0,
                });
                newConfigs[index] = {
                  serviceId: serviceName,
                  rateType: "",
                  basisType: "",
                };
              }
            });

            form.setValue("services", newServices, { shouldValidate: false });
            setServiceConfigs(newConfigs);
          } finally {
            setTimeout(() => {
              isUpdatingFormRef.current = false;
            }, 50);
          }
        }, 0);
      }
    });

    return () => subscription.unsubscribe();
  }, [form]);

  // ============================================================================
  // WATCH FOR RATE TYPE AND BASIS TYPE CHANGES
  // ============================================================================
  useEffect(() => {
    const subscription = form.watch((value, { name }) => {
      if (
        name &&
        name.includes("services.") &&
        (name.includes(".rateType") || name.includes(".basisType")) &&
        !isUpdatingFormRef.current
      ) {
        const match = name.match(/services\.(\d+)\.(rateType|basisType)/);
        if (match) {
          const serviceIndex = parseInt(match[1], 10);
          const fieldChanged = match[2];
          const services = value.services || [];
          const currentService = services[serviceIndex];

          if (currentService) {
            const newRateType = currentService.rateType || "";
            const newBasisType = currentService.basisType || "";

            isUpdatingFormRef.current = true;

            setTimeout(() => {
              try {
                setServiceConfigs((prev) => ({
                  ...prev,
                  [serviceIndex]: {
                    serviceId: currentService.name,
                    rateType: newRateType,
                    basisType: newBasisType,
                  },
                }));

                if (fieldChanged === "rateType") {
                  form.setValue(`services.${serviceIndex}.rateName`, "", {
                    shouldValidate: false,
                  });
                  form.setValue(`services.${serviceIndex}.basisType`, "", {
                    shouldValidate: false,
                  });

                  setRateNameOptionsCache((prev) => {
                    const newCache = { ...prev };
                    delete newCache[serviceIndex];
                    return newCache;
                  });
                } else if (fieldChanged === "basisType") {
                  form.setValue(`services.${serviceIndex}.rateName`, "", {
                    shouldValidate: false,
                  });

                  setRateNameOptionsCache((prev) => {
                    const newCache = { ...prev };
                    delete newCache[serviceIndex];
                    return newCache;
                  });
                }

                setForceRender((prev) => prev + 1);
              } finally {
                setTimeout(() => {
                  isUpdatingFormRef.current = false;
                }, 50);
              }
            }, 0);
          }
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [form]);

  // ============================================================================
  // DETERMINE WHICH FETCHERS TO RENDER
  // ============================================================================
  const fetchersData = useMemo(() => {
    const result: Array<{
      serviceIndex: number;
      serviceId: string;
      rateType: string;
      basisType: string;
      basisTypeValue: string;
      needsBasisTypeFetch: boolean;
      needsRateNameFetch: boolean;
    }> = [];

    Object.entries(serviceConfigs).forEach(([indexStr, config]) => {
      const serviceIndex = parseInt(indexStr, 10);
      const { serviceId, rateType, basisType } = config;

      if (!rateType) return;

      const needsBasisTypeFetch =
        rateType === "1" && !basisTypeOptionsCache[rateType];

      let needsRateNameFetch = false;
      let basisTypeValue = "";

      if (rateType === "0") {
        needsRateNameFetch = !rateNameOptionsCache[serviceIndex];
      } else if (rateType === "1") {
        if (basisType) {
          const basisTypeOption = basisTypeOptionsCache[rateType]?.find(
            (opt) => String(opt.value) === String(basisType)
          );
          basisTypeValue = basisTypeOption?.label || "";

          needsRateNameFetch =
            !!basisTypeValue && !rateNameOptionsCache[serviceIndex];
        }
      }

      result.push({
        serviceIndex,
        serviceId,
        rateType,
        basisType,
        basisTypeValue,
        needsBasisTypeFetch,
        needsRateNameFetch,
      });
    });

    return result;
  }, [
    serviceConfigs,
    basisTypeOptionsCache,
    rateNameOptionsCache,
    forceRender,
  ]);

  // ============================================================================
  // HANDLE FORM SUBMISSION - FIXED WITH PROPER LOCALSTORAGE UPDATE
  // ============================================================================
  const handleSubmit = async (formData: any) => {
    console.log("📤 Submitting form data:", formData);

    try {
      clearValidationError?.();

      const services = formData.services || [];
      const selectedServices = formData.selectedServices || [];

      if (selectedServices.length === 0) {
        setValidationError?.("Please select at least one utility service");
        return;
      }

      // Validate each service
      for (let i = 0; i < services.length; i++) {
        const service = services[i];

        if (!service.rateType) {
          setValidationError?.(`Please select rate type for ${service.name}`);
          return;
        }

        if (service.rateType === "1" && !service.basisType) {
          setValidationError?.(`Please select basis type for ${service.name}`);
          return;
        }

        if (!service.rateName) {
          setValidationError?.(`Please select rate name for ${service.name}`);
          return;
        }
      }

      // Transform to API payload (snake_case)
      const utilityServiceData: Record<string, any> = {};
      const utilityServiceDataForParent: Record<string, any> = {};

      services.forEach((service: any) => {
        utilityServiceData[service.name] = {
          type: parseInt(service.rateType),
          basis: service.rateType === "1" ? parseInt(service.basisType) : null,
          rate: service.rateName,
          avg_consumption: service.avgConsumption || 0,
          avgConsumption: service.avgConsumption || 0, // Keep both for compatibility
        };

        utilityServiceDataForParent[service.name] = {
          rateType: service.rateType,
          basisType: service.basisType,
          rateName: service.rateName,
          avgConsumption: service.avgConsumption || 0,
        };
      });

      const payload = {
        utility_service: selectedServices,
        utility_service_data: {
          rate: utilityServiceData,
        },
        current_step: 3,
        remote_utility_id: utilityId,
      };

      console.log("🚀 Submitting Step 3 Payload:", payload);

      await updatePlanMutation.mutateAsync(payload);

      // FIXED: Properly update localStorage with step 2 data
      const planSpecificKey = `utility-plan-progress-${planId}`;
      
      try {
        const storedData =
          localStorage.getItem(planSpecificKey) ||
          localStorage.getItem("utility-plan-progress");

        if (storedData) {
          const parsed = JSON.parse(storedData);

          // Update step 2 data with complete information
          parsed.stepData = {
            ...parsed.stepData,
            2: {
              utilityService: selectedServices,
              rateData: utilityServiceData,
              selectedServices: selectedServices,
              utility_service_data: utilityServiceDataForParent,
            },
          };

          parsed.timestamp = Date.now();

          localStorage.setItem(planSpecificKey, JSON.stringify(parsed));
          localStorage.setItem("utility-plan-progress", JSON.stringify(parsed));

          console.log("💾 LocalStorage step[2] updated:", parsed.stepData[2]);
        }
      } catch (error) {
        console.error("⚠️ Failed to update localStorage:", error);
      }

      // Update parent with both formats
      const dataToSave = {
        utilityService: selectedServices,
        rateData: utilityServiceData,
        selectedServices: selectedServices,
        utility_service_data: utilityServiceDataForParent,
      };

      onDataChange?.(dataToSave);
      stepChange?.(dataToSave);

      onNext?.();
    } catch (error) {
      console.error("❌ Submission failed", error);
      setValidationError?.("An error occurred while saving. Please try again.");
    }
  };

  const handleReset = () => {
    form.reset();
    setServiceConfigs({});
    setRateNameOptionsCache({});
    setBasisTypeOptionsCache({});
    setIsFormPopulated(false);
    lastSelectedServicesRef.current = [];
  };

  // ============================================================================
  // RESET FORM WHEN DATA CHANGES (CRITICAL FOR NAVIGATION)
  // ============================================================================
  useEffect(() => {
    // Check if data actually changed
    const dataString = JSON.stringify(data);
    const lastDataString = JSON.stringify(lastDataRef.current);

    if (dataString !== lastDataString) {
      console.log("📊 Data changed, resetting form population flag");
      lastDataRef.current = data;
      setIsFormPopulated(false);
    }
  }, [data]);

  // ============================================================================
  // CUSTOM FOOTER RENDERING
  // ============================================================================
  const renderCustomFooter = useCallback(
    () => (
      <div className="space-y-4">
        {loadingUtilityServices && (
          <div className="p-4 bg-blue-50 border border-blue-200 rounded-md">
            <div className="flex items-center space-x-2">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
              <span className="text-sm text-blue-800">
                Loading utility services...
              </span>
            </div>
          </div>
        )}

        {!loadingUtilityServices && utilityServices.length === 0 && (
          <div className="p-4 bg-red-50 border border-red-200 rounded-md">
            <div className="flex items-start">
              <Info className="w-5 h-5 text-red-500 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h4 className="text-sm font-medium text-red-800">
                  No Utility Services Available
                </h4>
                <p className="mt-1 text-sm text-red-700">
                  No active utility services found. Please configure utility
                  services first.
                </p>
              </div>
            </div>
          </div>
        )}

        {!loadingUtilityServices &&
          utilityServices.length > 0 &&
          form.watch("selectedServices")?.length === 0 && (
            <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-md">
              <div className="flex items-start">
                <Info className="w-5 h-5 text-yellow-500 mt-0.5 mr-3 flex-shrink-0" />
                <div>
                  <h4 className="text-sm font-medium text-yellow-800">
                    No Services Selected
                  </h4>
                  <p className="mt-1 text-sm text-yellow-700">
                    Please select at least one utility service to configure
                    rates.
                  </p>
                </div>
              </div>
            </div>
          )}

        <div className="flex justify-between pt-6 border-t border-gray-200">
          <button
            type="button"
            onClick={onPrevious}
            disabled={isFirstStep}
            className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-200 transition-colors"
          >
            <ChevronLeft className="inline w-4 h-4 mr-1" />
            Previous
          </button>

          <button
            type="submit"
            disabled={
              loadingUtilityServices ||
              utilityServices.length === 0 ||
              form.watch("selectedServices")?.length === 0
            }
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            Next
            <ChevronRight className="inline w-4 h-4 ml-1" />
          </button>
        </div>
      </div>
    ),
    [isFirstStep, onPrevious, loadingUtilityServices, utilityServices, form]
  );

  if (loadingUtilityServices) {
    return (
      <div className="space-y-6">
        <div className="p-8 text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading utility services...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {fetchersData
        .filter((d) => d.needsBasisTypeFetch)
        .map(({ rateType }) => (
          <BasisTypeFetcher
            key={`basis-${rateType}-${forceRender}`}
            rateTypeKey={rateType}
            onDataReceived={handleBasisTypeOptionsReceived}
          />
        ))}

      {fetchersData
        .filter((d) => d.needsRateNameFetch)
        .map(({ serviceIndex, serviceId, rateType, basisTypeValue }) => (
          <RateNameFetcher
            key={`rate-${serviceIndex}-${rateType}-${basisTypeValue}-${forceRender}`}
            serviceId={serviceId}
            serviceIndex={serviceIndex}
            rateTypeKey={rateType}
            basisTypeValue={basisTypeValue}
            onDataReceived={handleRateNameOptionsReceived}
          />
        ))}

      <Button size="sm" onClick={() => navigate("/plan-tarrif/tariff/add")}>
        <Plus className="h-4 w-4" /> Add New Tariff
      </Button>

      <DynamicForm
        fields={formFields}
        form={form}
        onSubmit={handleSubmit}
        onReset={handleReset}
        loading={loadingUtilityServices}
        gridColumns={2}
        responsiveColumns={{
          sm: 1,
          md: 2,
        }}
        config={{
          showProgress: false,
          layout: "vertical",
          spacing: "none",
          submitButtonText: "Next",
          showResetButton: false,
          resetOnSubmit: false,
          classes: {
            form: "space-y-0",
            fieldContainer: "",
            buttonContainer: "hidden",
            fieldGroup: "",
          },
        }}
        renderCustomFooter={renderCustomFooter}
        className=""
        style={{
          background: "transparent",
          border: "none",
          boxShadow: "none",
        }}
      />
    </div>
  );
};

export default UtilityServicesStep;